// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import AccordeonGroupController from "./accordeon-group_controller.js";
import AnimationController from "./animation_controller.js";
import { application } from "./application";
import CuratorController from "./curator_controller.js";
import FadeInController from "./fade-in_controller.js";
import FadeInChildsController from "./fade-in-childs_controller.js";
import GoogleMapController from "./googlemap_controller.js";
import HeaderController from "./header_controller.js";
import HistoryController from "./history_controller.js";
import LockscrollController from "./lockscroll_controller.js";
import LottieController from "./lottie_controller.js";
import MessageBannerController from "./message-banner_controller.js";
import NewsletterController from "./newsletter_controller.js";
import OrderPopupController from "./order-popup_controller.js";
import LocationPopupController from "./location-popup_controller.js";
import ParallaxController from "./parallax_controller.js";
import PriceCalculatorController from "./price-calculator_controller.js";
import QuantityController from "./quantity_controller.js";
import SimpleFiltersController from "./simple-filters_controller.js";
import SwiperController from "./swiper_controller.js";
import TabsController from "./tabs_controller.js";
import DropdownFiltersController from "./dropdown-filters_controller.js";
import CopyToClipboard from "./copy-to-clipboard_controller.js";
import FormController from "./form_controller.js";
import CartCountController from "./cart-count_controller.js";
import VidstackController from "./vidstack_controller.js";
import CartButtons from "./cart-buttons.js";
import GreetingCardPopup from "./greeting-card-popup.js";
import TurnstileController from "./turnstile_controller";
import ChocoportraitController from "./chocoportrait_controller.js";
import FlavourPopupController from "./flavour-popup_controller.js";
import ChocoportraitSummaryController from "./chocoportrait-summary_controller.js";

// application.register("test", TestController);
application.register("header", HeaderController);
application.register("swiper", SwiperController);
application.register("order-popup", OrderPopupController);
application.register("lottie", LottieController);
application.register("lockscroll", LockscrollController);
application.register("parallax", ParallaxController);
application.register("animation", AnimationController);
application.register("fade-in", FadeInController);
application.register("fade-in-childs", FadeInChildsController);
application.register("accordeon-group", AccordeonGroupController);
application.register("price-calculator", PriceCalculatorController);
application.register("history", HistoryController);
application.register("tabs", TabsController);
application.register("googlemap", GoogleMapController);
application.register("message-banner", MessageBannerController);
application.register("simple-filters", SimpleFiltersController);
application.register("curator", CuratorController);
application.register("dropdown-filters", DropdownFiltersController);
application.register("copy-to-clipboard", CopyToClipboard);
application.register("quantity", QuantityController);
application.register("location-popup", LocationPopupController);
application.register("form", FormController);
application.register("cart-count", CartCountController);
application.register("newsletter", NewsletterController);
application.register("vidstack", VidstackController);
application.register("cart-buttons", CartButtons);
application.register("greeting-card-popup", GreetingCardPopup);
application.register("turnstile", TurnstileController);
application.register("chocoportrait", ChocoportraitController);
application.register("flavour-popup", FlavourPopupController);
application.register("chocoportrait-summary", ChocoportraitSummaryController);



